<script setup lang="ts">
import { onMounted, ref } from "vue";
import { fetch } from "@/plugins/fetchPlugin";
import NoticeView from "@/components/NoticeFormView.vue";

// eslint-disable-next-line no-undef
const props = defineProps({
  operationId: {
    type: String,
    default: undefined,
  },
  op: {
    type: Object,
    default: undefined,
  },
  subId: {
    type: String,
    default: undefined,
  },
});

const notice = ref(false);

const sended = ref(false);

const error = ref({
  lastname: false,
  firstname: false,
  email: false,
  type: false,
  subject: false,
  message: false,
});

const form = ref({
  lastname: "",
  firstname: "",
  email: "",
  type: "",
  subject: "",
  message: "",
});

const sendEmail = async () => {
  try {
    if (!form.value.lastname) {
      error.value.lastname = true;
    }
    if (!form.value.firstname) {
      error.value.firstname = true;
    }
    if (!form.value.email) {
      error.value.email = true;
    }
    if (!form.value.type) {
      error.value.type = true;
    }
    if (!form.value.subject) {
      error.value.subject = true;
    }
    if (!form.value.message) {
      error.value.message = true;
    }

    if (
      !form.value.lastname ||
      !form.value.firstname ||
      !form.value.email ||
      !form.value.type ||
      !form.value.subject ||
      !form.value.message
    ) {
      return;
    }

    let to = null;

    await fetch(`/api/operations-custom/promodev-send-contact/sendmail`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        to: to,
        subid: props.subId,
        operationId: props.operationId,
        nom: form.value.lastname,
        prenom: form.value.firstname,
        email: form.value.email,
        demande: form.value.type,
        objet: form.value.subject,
        message: form.value.message,
        type: "contact",
      }),
    });

    sended.value = true;
  } catch (e) {
    console.error(e);
  }
};

onMounted(() => {
  if (props.op.custom.rgpdcontact) {
    const noticeElement = document.getElementById("notice");
    if (noticeElement) {
      noticeElement.addEventListener("click", () => {
        notice.value = true;
      });
    }
  }
});
</script>
<template>
  <div class="contact_wrapper h-full w-full relative">
    <div
      v-if="notice"
      class="inset-0 w-full bg-primary-bg text-primary-text overflow-auto absolute p-4"
    >
      <NoticeView />
      <p class="text-center mt-2 mb-4">
        <button @click="notice = false" class="button">
          {{ $t("done.button") }}
        </button>
      </p>
    </div>
    <form
      v-if="!notice && !sended"
      class="flex flex-wrap justify-between"
      @submit.prevent="sendEmail"
    >
      <p class="step w-full text-primary-text">{{ $t("contact.title") }}</p>

      <div class="w-[49%]">
        <label>{{ $t("contact.lastname") }}<span>*</span></label>
        <input
          type="text"
          v-model="form.lastname"
          :class="{ 'has-error': error.lastname }"
        />
        <span class="error" v-if="error.lastname">{{
          $t("contact.required")
        }}</span>
      </div>
      <div class="w-[49%]">
        <label>{{ $t("contact.firstname") }} <span>*</span></label>
        <input
          type="text"
          v-model="form.firstname"
          :class="{ 'has-error': error.firstname }"
        />
        <span class="error" v-if="error.firstname">{{
          $t("contact.required")
        }}</span>
      </div>
      <div class="w-full">
        <label>{{ $t("contact.email") }} <span>*</span></label>
        <input
          type="email"
          v-model="form.email"
          :class="{ 'has-error': error.email }"
        />
        <span class="error" v-if="error.email">{{
          $t("contact.required")
        }}</span>
      </div>
      <div class="w-full">
        <label>{{ $t("contact.ask") }} <span>*</span></label>
        <select v-model="form.type" :class="{ 'has-error': error.type }">
          <option></option>
          <option>{{ $t("contact.asks.ask1") }}</option>
          <option>{{ $t("contact.asks.ask2") }}</option>
          <option>{{ $t("contact.asks.ask3") }}</option>
          <option>{{ $t("contact.asks.ask4") }}</option>
          <option>{{ $t("contact.asks.ask5") }}</option>
          <option>{{ $t("contact.asks.ask6") }}</option>
          <option>{{ $t("contact.asks.ask7") }}</option>
          <option>{{ $t("contact.asks.ask8") }}</option>
          <option>{{ $t("contact.asks.ask9") }}</option>
          <option>{{ $t("contact.asks.ask10") }}</option>
          <option>{{ $t("contact.asks.ask11") }}</option>
        </select>
        <span class="error" v-if="error.type">{{
          $t("contact.required")
        }}</span>
      </div>
      <div class="w-full">
        <label>{{ $t("contact.subject") }} <span>*</span></label>
        <input
          type="text"
          v-model="form.subject"
          :class="{ 'has-error': error.subject }"
        />
        <span class="error" v-if="error.subject">{{
          $t("contact.required")
        }}</span>
      </div>
      <div class="w-full">
        <label>{{ $t("contact.message") }} <span>*</span></label>
        <textarea
          class="w-full h-[8em]"
          v-model="form.message"
          :class="{ 'has-error': error.message }"
        />
        <span class="error" v-if="error.message">{{
          $t("contact.required")
        }}</span>
      </div>
      <div>
        <p class="text-xs py-2">
          <span class="text-red-500">*</span> Champs obligatoires
        </p>
      </div>
      <p
        class="!text-xs rounded p-2"
        v-if="op.custom.rgpdcontact"
        v-html="
          op.custom.rgpdcontact.replace(
            '[notice]',
            '<a id=notice>notice ci-jointe</a>'
          )
        "
      ></p>
      <div
        v-else
        class="w-full bg-gray-100 text-[.8em] leading-[1.2em] p-[.7em] rounded mt-[.5em]"
      >
        {{ $t("contact.rgpd") }}
        <a class="underline cursor-pointer" @click="notice = true">{{
          $t("contact.rgpd_link")
        }}</a>
      </div>
      <div class="builder-buttons py-[1em] w-full !justify-center">
        <button type="submit">
          <i class="fa-regular fa-paper-plane mr-[.5em]"></i>
          {{ $t("contact.send") }}
        </button>
      </div>
    </form>
    <div
      v-if="sended && !notice"
      class="h-full flex items-center justify-center w-full text-primary-text"
    >
      <div>
        <div class="w-full text-center pt-8">
          <i
            class="floating-div fa-regular text-green-500 fa-circle-check text-[90px] m-auto"
          ></i>
        </div>

        <h2 class="text-2xl font-bold text-center w-full pt-8">
          {{ $t("contact.success_title") }}
        </h2>
        <p class="py-6 max-w-sm m-auto">
          {{ $t("contact.success") }}
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error {
  display: none !important;
}

label span {
  color: red;
}

.slide-left {
  transform: translateX(-100%);
}

.slide-right {
  transform: translateX(100%);
}

.slide-right.slide-reset,
.slide-left.slide-reset {
  transform: translateX(0%);
}

/* Animations de transition */

.slide-leave-active,
.slide-enter-active {
  transition: 0.2s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
</style>
